import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import cn from 'classnames';
import NoFunctionalCookies from './NoFunctionalCookies';
import Cookies from 'universal-cookie';
import {useFooterContext} from '../Footer/FooterContext';
import HTMLSource from './HTMLSource';


const HTMLSourceParagraph = ({ fieldHtml, alignment, width, height, id, langcode }) => {
    const { context: { shouldReload } } = useFooterContext();
    const widthClass = `content-image${width || 100}`;
    const paragraphClasses = `paragraph__html_source paragraph__html_source_${id}`;
    const cookies = new Cookies();
    const functionalCookiesAccepted = cookies.get('functionalCookiesAccepted');

    useEffect(() => {
        if (shouldReload) {
            window?.location?.reload();
        }
    }, [shouldReload]);

    return (
        <div
            key={uniqueId()}
            data-source-id={id}
            className={cn('html-source', widthClass, paragraphClasses, {
                'left-align': alignment === 'Align left',
                'right-align': alignment === 'Align right',
            })}
            style={
                height
                    ? {
                        height: `${height}px`,
                        overflow: 'auto',
                    }
                    : {}
            }
        >
            {!shouldReload && functionalCookiesAccepted && <HTMLSource html={fieldHtml} height={height} />}
            {!shouldReload && !functionalCookiesAccepted && <NoFunctionalCookies langcode={langcode} />}
        </div>
    );
};

export default HTMLSourceParagraph;

HTMLSourceParagraph.propTypes = {
    fieldHtml: PropTypes.string,
    id: PropTypes.string,
    alignment: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    langcode: PropTypes.string,
};
